import React, { useCallback, useState, useRef, useMemo, useEffect } from 'react';
import { Grid } from 'antd';
import { useSelector } from 'react-redux';
import indexStyles from '../index.less';
import { localeSelector } from 'src/selector/app';
import { JoinClassName } from 'src/utils/utils';
import Image from 'next/image';
import CommonSection from '../CommonSection';
import FrozenRatio from 'src/components/FrozenRatio/FrozenRatio';

const { useBreakpoint } = Grid;
const FrequentlyAskedQuestions = ({ content }) => {
  const screens = useBreakpoint();
  const local = useSelector(localeSelector);
  let [activeIndex, setActiveIndex] = useState(0);
  let [autoTrigger, setAutoTrigger] = useState(true);
  let [containerHeight, setContainerHeight] = useState('auto');
  let timerRef = useRef(null);
  const leftItemListRef = useRef(null);

  const onToggleQuestion = useCallback((index) => {
    setActiveIndex((prev) => {
      if (prev === index) {
        return -1;
      }
      return index;
    });
  }, []);
  return (
    <CommonSection
      title={content.title}
      desc={content.desc}
      className={indexStyles.max1440Width}
      outerClassName={JoinClassName(indexStyles.whiteBackgroundcolor, indexStyles.frequentlyAskedQuestionsSection)}
    >
      <div className={JoinClassName(indexStyles.frequentlyAskedQuestions)}>
        <div className={JoinClassName(indexStyles.frequentlyAskedQuestionsItemList)} ref={leftItemListRef}>
          {content.items.map(({ question, answer }, index) => {
            return (
              <div
                className={JoinClassName(
                  indexStyles.frequentlyAskedQuestionsItem,
                  index == activeIndex ? indexStyles.expand : ''
                )}
                data-index={index}
                key={index}
              >
                <h3
                  className={JoinClassName(indexStyles.frequentlyAskedQuestion)}
                  onClick={() => onToggleQuestion(index)}
                >
                  {question}
                </h3>
                <p
                  className={JoinClassName(indexStyles.frequentlyAskedQuestionAnswer)}
                  dangerouslySetInnerHTML={{ __html: answer }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </CommonSection>
  );
};

export default FrequentlyAskedQuestions;
